import React, { useState, useEffect } from "react";
import { IoChevronForwardOutline } from "react-icons/io5";
import LibraryChapterProps from "./LibraryChapter/LibraryChapterProps";
import "./LibrarySubjectDetail.css";
import LibraryChapterDetails from "./LibraryChapter/LibraryChapterDetails";
import { handleIcons } from "./iconData";
import { useLocation, useParams } from "react-router-dom";
import axios from "../../../axios";
import { iconData } from "../../../iconData";
import { IP } from "../../../internalServer";
import { useNavigate } from "react-router-dom";

export default function LibrarySubjectDetail({
  handleSubjectDetailClose,
  handleSubjectContinueClose,
}) {
  let detail = JSON.parse(localStorage.getItem("breathForStudent"));
  const { state } = useLocation();
  const navigate = useNavigate();
  localStorage.setItem("std", state.standard_id);
  localStorage.setItem("sec", state.section_id);
  localStorage.setItem("sub", state.subject_id);
  let data = JSON.parse(localStorage.getItem("breathForStudent"));

  useEffect(() => {
    try {
      async function getGroup() {
        const res = await axios.get(
          `/group/filterForStudent/studentId/${data.id}?standardId=${state.standard_id}&sectionId=${state.section_id}&subjectId=${state.subject_id}`,
        );
      }
      getGroup();
    } catch (error) {
      console.log(error);
    }
  }, []);

  const [subjectDetailExpanded, setSubjectDetailExpanded] = useState(null);
  const [subjectDetail, setSubjectDetail] = useState(true);
  const [bookData, setBookData] = useState([]);
  const [userDetail, setUserDetail] = useState();
  const [isBookLoading, setIsBookLoading] = useState(true);
  const [isLastSeenLoading, setIsLastSeenLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(true); // full page loader

  const [clickedSubject, setClickedSubject] = useState();
  const [librarySubDetail, setLibrarySubDetail] = useState({
    picupPopChapter: false,
    progress1: 50,
    progress2: 40,
    chapterDetail: false,
  });
  useEffect(() => {
    let detail = JSON.parse(localStorage.getItem("breathForStudent"));
    setUserDetail(detail);
  }, []);
  const handleBookExpand = (index) => {
    if (subjectDetailExpanded === index) {
      setSubjectDetailExpanded(null);
    } else {
      setSubjectDetailExpanded(index);
    }
  };

  const handleClosePicUpPopup = () => {
    setLibrarySubDetail({
      ...librarySubDetail,
      picupPopChapter: false,
    });
  };

  useEffect(() => {
    const handleBookHelper = async () => {
      setIsBookLoading(true);

      try {
        let res = await axios.get(
          `/cm/library/book/getBookByClassSectionSubject?standard_id=${state.standard_id}&section_id=${state.section_id}&subject_id=${state.subject_id}&timetableSessionId=${data?.timetable_session?.id}`,
        );

        setBookData(res.data.data[0].bookInfo);
        setClickedSubject(localStorage.getItem("LibSubj"));
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(() => setIsBookLoading(false), 200); // smoother UI
      }
    };

    handleBookHelper();
  }, []);

  const [lastSeen, setLastSeen] = useState();
  const getLastSeen = async () => {
    setIsLastSeenLoading(true);

    try {
      let res = await axios.get(
        `/cm/library/book/getUserLastSeenStampByUserId?user_id=${detail?.id}&subject_id=${state.subject_id}&standardID=${detail?.standard?.id}&sectionID=${detail?.section?.id}&timetableSessionID=${detail?.timetable_session?.id}`,
      );

      setLastSeen(res.data.data);
      res.data.data &&
        localStorage.setItem("LastSeen", JSON.stringify(res.data.data));
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => setIsLastSeenLoading(false), 150);
    }
  };
  useEffect(() => {
    if (!isBookLoading && !isLastSeenLoading) {
      setTimeout(() => setPageLoading(false), 100);
    }
  }, [isBookLoading, isLastSeenLoading]);

  useEffect(() => {
    getLastSeen();
  }, []);
  const [index, setIndex] = useState();
  useEffect(() => {
    bookData[0]?.chapterData?.forEach((obj, index) => {
      if (lastSeen?.chapterID?.id === obj?.id) {
        setIndex(index);
      }
    });
  }, [lastSeen, bookData]);
  const [isContinue, setIsContinue] = useState(0);
  useEffect(() => {
    localStorage.setItem("isContinue", isContinue);
  }, [isContinue]);

  if (pageLoading) {
    return (
      <div className="w-full h-[70vh] flex justify-center items-center">
        <div className="w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <>
      {!librarySubDetail.chapterDetail && (
        <div className="m-2">
          <div className="d-flex gap-1 align-items-center">
            <div
              className="path_subject_library"
              onClick={() => window.history.back()}
            >
              Library
            </div>
            <IoChevronForwardOutline />
            <div className="path_subject_library">{clickedSubject}</div>
          </div>

          <div className="m-3">
            <div className="d-flex justify-content-between">
              <div className="d-flex gap-2 totalContainerSubjetBx align-items-center">
                <div>
                  <img
                    src={handleIcons(clickedSubject)}
                    alt="Book img"
                    style={{ width: "50px" }}
                  />
                </div>
                <div>
                  <div className="subjectNames">{clickedSubject}</div>
                  <div>
                    {bookData?.length} {bookData?.length > 1 ? "Books" : "Book"}
                  </div>
                </div>
              </div>
              {subjectDetail &&
                (isLastSeenLoading ? (
                  <div className="w-full bg-gray-100 p-4 rounded-lg animate-pulse h-20"></div>
                ) : (
                  lastSeen && (
                    <div className="containerPlayAudio ">
                      <div className="d-flex justify-content-between">
                        <div className="PickUpWhereTxt">
                          Pickup where you left off?
                        </div>
                        <div>
                          {" "}
                          <img
                            src="/LibraryImg/CrossLibrary.png"
                            onClick={() => {
                              setSubjectDetail(false);
                            }}
                            alt="mx img"
                          />
                        </div>
                      </div>
                      <div className="d-flex gap-2">
                        <div>
                          {" "}
                          {lastSeen?.contentInfo?.fileInfo?.fileType ===
                            "audio" && (
                            <img
                              src="/ContentM_images/SoundIcon.svg"
                              alt="sound logo"
                              className="iconSTyl"
                            ></img>
                          )}
                          {lastSeen?.contentInfo?.fileInfo?.fileType ===
                            "mp3" && (
                            <img
                              src="/ContentM_images/SoundIcon.svg"
                              alt="sound logo"
                            ></img>
                          )}
                          {lastSeen?.contentInfo?.fileInfo?.fileType ===
                            "pdf" && (
                            <img
                              src="/ContentM_images/PdfBlackIcon.svg"
                              alt="sound logo"
                            ></img>
                          )}
                          {lastSeen?.contentInfo?.fileInfo?.fileType ===
                            "img" && (
                            <img
                              src="/ContentM_images/PdfBlackIcon.svg"
                              alt="sound logo"
                            ></img>
                          )}
                          {lastSeen?.contentInfo?.fileInfo?.fileType ===
                            "png" && (
                            <img
                              src="/ContentM_images/PdfBlackIcon.svg"
                              alt="sound logo"
                            ></img>
                          )}
                          {lastSeen?.contentInfo?.fileInfo?.fileType ===
                            "jpg" && (
                            <img
                              src="/ContentM_images/PdfBlackIcon.svg"
                              alt="sound logo"
                            ></img>
                          )}
                          {lastSeen?.contentInfo?.fileInfo?.fileType ===
                            "svg" && (
                            <img
                              src="/ContentM_images/PdfBlackIcon.svg"
                              alt="sound logo"
                            ></img>
                          )}
                          {lastSeen?.contentInfo?.fileInfo?.fileType ===
                            "video" && (
                            <img
                              src="/ContentM_images/PlayIcon.svg"
                              alt="sound logo"
                            ></img>
                          )}
                          {lastSeen?.contentInfo?.fileInfo?.fileType ===
                            "mp4" && (
                            <img
                              src="/ContentM_images/PlayIcon.svg"
                              alt="sound logo"
                            ></img>
                          )}
                        </div>
                        <div className="mainContainerLeftOver">
                          <div className="bookChapterName">
                            {lastSeen?.bookID?.bookName}:{" "}
                            {lastSeen?.chapterID?.chapterName}
                          </div>
                          <div className="d-flex justify-content-between ">
                            <div className="timeVideo">
                              {"Last Seen " + lastSeen.lastSeenStamp}
                              {"s "}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "audio" && "audio"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "mp3" && "audio"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "video" && "min"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "mp4" && "min"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "pdf" && "pages"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "img" && ""}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "jpg" && ""}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "png" && ""}{" "}
                              •{" "}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "audio" && "audio"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "mp3" && "audio"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "video" && "video"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "mp4" && "video"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "pdf" && "e-book"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "img" && "img"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "png" && "img"}
                              {lastSeen?.contentInfo?.fileInfo?.fileType ===
                                "jpg" && "img"}
                            </div>
                            <div
                              className="hide_chapter"
                              onClick={(e) => {
                                navigate(
                                  `/Contents/ChapterDetails/${index}/${1}`,
                                  {
                                    state: {
                                      chapter_id: lastSeen.chapterID.id,
                                      subject_id: state.subject_id,
                                    },
                                  },
                                );
                                setIsContinue(1);
                              }}
                            >
                              Continue
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                ))}
            </div>

            {isBookLoading ? (
              <>
                {/* Shimmer block */}
                {[1, 2, 3].map((_, i) => (
                  <div
                    key={i}
                    className="p-4 bg-gray-200 rounded-lg animate-pulse mb-3 h-20"
                  ></div>
                ))}
              </>
            ) : (
              bookData?.length > 0 &&
              bookData?.map((obj, index) => (
                <div className="total_container_book p-1" key={index}>
                  <div className="d-flex">
                    <img
                      // src={
                      //   obj.thumbnailImage
                      //     ? IP + obj.thumbnailImage.replace(/^\./, "")
                      //     : "/LibraryImg/LibrarySubjectImg.svg "
                      // }
                      src="/images/Book_XS.png"
                      className="imageSize"
                      alt="Book img"
                    ></img>
                    <div className="mt-3 containerChapterNames">
                      <div className="book_title">
                        Book {index + 1}: {obj?.name}
                      </div>
                      <div className="chapters_Count mt-2">
                        {obj?.chapterData?.length} Chapters &nbsp;
                        <span onClick={() => handleBookExpand(index)}>
                          {subjectDetailExpanded === index ? (
                            <span className="hide_chapter">Hide Chapters</span>
                          ) : (
                            <span
                              className="hide_chapter"
                              onClick={() => {
                                localStorage.setItem(
                                  "clickedChap",
                                  JSON.stringify(bookData[index]),
                                );
                              }}
                            >
                              Show Chapters
                            </span>
                          )}
                        </span>
                      </div>

                      {/* <div className="totalContaineProgressBar ">
                        <div className="progressPersentage">
                          Progress: {`${obj.progressStatus}%`}
                        </div>
                        <div id="progress">
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{
                              width: `${obj.progressStatus}%`,
                              backgroundColor: ' #F78105',
                            }}
                            aria-valuenow={obj.progressStatus}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  {subjectDetailExpanded === index && (
                    <div
                      onClick={(e) =>
                        setLibrarySubDetail({
                          ...librarySubDetail,
                          chapterDetail: true,
                        })
                      }
                    >
                      <LibraryChapterProps
                        chapterData={bookData[index]?.chapterData}
                        books={bookData}
                        indexOfBook={index}
                        data={state}
                        bookId={obj?.id}
                      />
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      )}

      {/* {librarySubDetail.chapterDetail && <LibraryChapterDetails />} */}
    </>
  );
}
